/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Holds_NothingInputs */

const th_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีสิทธิ์พิเศษ — เห็นเฉพาะข้อมูลสาธารณะ`)
};

const en_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no relations — sees only what is public`)
};

const ja_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権限なし — 公開情報のみ閲覧できます`)
};

const zh_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何关联——只能看到公开内容`)
};

const es_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sin relaciones: solo ve lo que es público`)
};

const pt_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem relações — vê apenas o que é público`)
};

const id_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tanpa keterkaitan — hanya melihat yang publik`)
};

const fr_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aucune relation — ne voit que ce qui est public`)
};

const tl_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`walang ugnayan — nakikita lang ang pampubliko`)
};

const vi_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`không có liên hệ nào — chỉ thấy phần công khai`)
};

const ko_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결된 것 없음 — 공개된 내용만 볼 수 있음`)
};

const de_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keine Beziehungen — sieht nur, was öffentlich ist`)
};

const ru_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`без связей — видит только общедоступное`)
};

const tr_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hiçbir bağı yok — yalnızca herkese açık olanı görür`)
};

const it_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nessun collegamento: vede solo ciò che è pubblico`)
};

const pl_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bez żadnych powiązań — widzi tylko to, co publiczne`)
};

const uk_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`без зв'язків — бачить лише загальнодоступне`)
};

const hi_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई संबंध नहीं — केवल सार्वजनिक चीज़ें दिखती हैं`)
};

const ar_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلا أي ارتباط — لا يرى إلا ما هو عام`)
};

const ms_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tiada kaitan — hanya melihat yang awam`)
};

const bn_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও সংযোগ নেই — কেবল প্রকাশ্য জিনিস দেখে`)
};

const zh_tw2_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有任何關聯——只能看到公開內容`)
};

const zh_hk2_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有任何關聯——只能看到公開內容`)
};

const ur_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی تعلق نہیں — صرف عوامی چیزیں دیکھتا ہے`)
};

const fa_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بدون هیچ وابستگی — فقط چیزهای عمومی را می‌بیند`)
};

const sw_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hana uhusiano wowote — anaona yaliyo wazi tu`)
};

const nl_dev_holds_nothing = /** @type {(inputs: Dev_Holds_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geen enkele band — ziet alleen wat openbaar is`)
};

/**
* | output |
* | --- |
* | "no relations — sees only what is public" |
*
* @param {Dev_Holds_NothingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const dev_holds_nothing = /** @type {((inputs?: Dev_Holds_NothingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Holds_NothingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_dev_holds_nothing(inputs)
	if (locale === "ja") return ja_dev_holds_nothing(inputs)
	if (locale === "zh") return zh_dev_holds_nothing(inputs)
	if (locale === "es") return es_dev_holds_nothing(inputs)
	if (locale === "pt") return pt_dev_holds_nothing(inputs)
	if (locale === "id") return id_dev_holds_nothing(inputs)
	if (locale === "fr") return fr_dev_holds_nothing(inputs)
	if (locale === "tl") return tl_dev_holds_nothing(inputs)
	if (locale === "vi") return vi_dev_holds_nothing(inputs)
	if (locale === "ko") return ko_dev_holds_nothing(inputs)
	if (locale === "de") return de_dev_holds_nothing(inputs)
	if (locale === "ru") return ru_dev_holds_nothing(inputs)
	if (locale === "tr") return tr_dev_holds_nothing(inputs)
	if (locale === "it") return it_dev_holds_nothing(inputs)
	if (locale === "pl") return pl_dev_holds_nothing(inputs)
	if (locale === "uk") return uk_dev_holds_nothing(inputs)
	if (locale === "hi") return hi_dev_holds_nothing(inputs)
	if (locale === "ar") return ar_dev_holds_nothing(inputs)
	if (locale === "ms") return ms_dev_holds_nothing(inputs)
	if (locale === "bn") return bn_dev_holds_nothing(inputs)
	if (locale === "zh-TW") return zh_tw2_dev_holds_nothing(inputs)
	if (locale === "zh-HK") return zh_hk2_dev_holds_nothing(inputs)
	if (locale === "ur") return ur_dev_holds_nothing(inputs)
	if (locale === "fa") return fa_dev_holds_nothing(inputs)
	if (locale === "sw") return sw_dev_holds_nothing(inputs)
	if (locale === "nl") return nl_dev_holds_nothing(inputs)
	return en_dev_holds_nothing(inputs)
});